import {
  type DetailAdjuntoComunicadoModel,
  type DetailComunicadoModel,
  type EstadoComunicadoEnum,
  type TipoComunicadoEnum,
} from "@api/api";

export class ComunicadoDetailModel {
  Id!: string;
  Tipo!: TipoComunicadoEnum;
  Estado!: EstadoComunicadoEnum;
  Asunto!: string;
  Cuerpo!: string;
  TipoEmpresaAgenteDirigido!: string | null;
  RolesDirigidos!: string[];
  EmpresasAgentesDirigidos!: string[];
  Adjuntos!: DetailAdjuntoComunicadoModel[];
  PuedeEditarse!: boolean;
  PuedeEliminarse!: boolean;
  FechaCreacion!: Date;
  FechaUltModificacion!: Date | null;
  FechaEnvio!: Date | null;

  constructor(data?: DetailComunicadoModel) {
    if (data) {
      Object.assign(this, data);
      this.RolesDirigidos = data.RolesDirigidos.map((rol) => rol.Denominacion);
      this.EmpresasAgentesDirigidos = data.EmpresasAgentesDirigidos.map((empresa) => empresa.Denominacion);
    }
  }

  static fromApi(data: DetailComunicadoModel): ComunicadoDetailModel {
    return new ComunicadoDetailModel(data);
  }

  esValorTodos(valor: string | null | undefined): boolean {
    return valor == null || valor === "";
  }

  get rutasAdjuntos(): string[] {
    return this.Adjuntos?.map(adjunto => adjunto.Ruta) ?? [];
  }
}
